<template>
    <div v-if="isAllowed" @click="promptForConfirmation()">
        <slot />

        <Modal v-if="isAwaitingConfirmation"
            @confirm="logInAsAthlete()"
            @cancel="isAwaitingConfirmation = false"
            :athleteName="athleteName"
        />

        <OverlaySpinner v-if="isInProgress" />
    </div>
</template>

<script>
import api from '@/services/api'
import { mapGetters } from 'vuex'
import Modal from './Modal'
import OverlaySpinner from '@/components/OverlaySpinner'

export default {
    components: { Modal, OverlaySpinner },

    props: {
        athleteName: { type: String, required: true },
        athleteId: { required: true },
    },

    data() {
        return {
            isAwaitingConfirmation: false,
            isInProgress: false,
        }
    },

    computed: {
        ...mapGetters('athleteProfile', ['organizations']),

        isAllowed() {
            return !!this.organizations.find(o => o.id == api.clientData('user_club_id') && o.isPaid)
        },
    },

    methods: {
        promptForConfirmation() {
            this.isAwaitingConfirmation = true
        },

        logInAsAthlete() {
            this.isInProgress = true

            $.ajax({
                url: '/authenticate/club_login',
                type: 'POST',
                data: {
                    user_id: this.athleteId,
                    url: window.location.href,
                },
                success: () => {
                    window.location = window.location.origin;
                },
            })
        }
    }
}
</script>